<template>
<div class="login">
    <div class="login_form_top">
        <h1 class="title">ログイン</h1>
    </div>
    <div class="formBox">
        <h2 class="itemLabel">ユーザーID</h2>
        <div class='validErrMsg' v-for="(err) in $v.loginId.errMsg" :key="err">{{ err }}</div>
        <input type="text" v-model="loginId" @input="valid($v.loginId, 'ユーザーID')">
        <h2 class="itemLabel">パスワード</h2>
        <div class='validErrMsg' v-for="(err) in $v.passwd.errMsg" :key="err">{{ err }}</div>
        <input type="password" v-model="passwd" @input="valid($v.passwd, 'パスワード')" >
    <input type="text" class="none" v-model="tmp">
    <button class="btn" @click="login">ログイン</button>
    </div>
</div>
</template>
<script>
import {loginRepository} from '@/Repositories/loginRepository.js'
import { required} from "vuelidate/lib/validators";
import check from '@/common/commonCheck';
export default {
    data() {
        return {
            loginId:'',
            passwd:'',
            tmp:''
        }
    },
    methods:{
        login(){
            let vm = this;
            if(!vm.validAll()) return;
            loginRepository.methods.Login(vm.loginId,vm.passwd)
            .then(res=>{
                vm.$functions.setSStorage('userInfo', res.data);
                sessionStorage.setItem('userId', vm.loginId);
                vm.$router.push({
                    path: '/itemList/1'
                })
            }).catch(()=>{;});
        },
        valid(v, name, regexType){
            check.checkStr(v, name, regexType);
        },
        validAll(){
            let vm = this;
            try{
                if(!check.checkStr(vm.$v.loginId, 'ユーザーID'))  throw 'userId';
                if(!check.checkStr(vm.$v.passwd, 'パスワード')) throw 'passwd';
            }catch(e){
                vm.tmp = 'tmp';
                return false;
            }
            return true;
        },
    },
    created(){
        sessionStorage.clear();
    },
    validations: {
        loginId:{
            required
        },
        passwd:{
            required
        }
    }
}
</script>
<style scoped lang="scss">
@import "../style/login.scss";
</style>